import React, {useEffect} from 'react'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import {MenuItem, FormControl} from '@material-ui/core'
import {MultilineChartRounded} from '@material-ui/icons'
import MultipleFieldSelect from './MultipleFieldSelect'

export default function LikeNotLike({type, onChange = (e, key, value, typeId) => {}, idx, data}) {
  const type_id = type?.id

  useEffect(() => {
    onChange('', 'list_filters_attributes', 'false', 'invert_query', idx, '', type_id)
    // eslint-disable-next-line
  }, [])

  return (
    <FormControl variant="outlined" style={{width: '100%'}}>
      <InputLabel id="demo-simple-select-outlined-label">Like / Not Like</InputLabel>
      <Select
        labelId="demo-simple-select-outlined-label"
        id={type ? type.id : 'demo-simple-select-outlined'}
        name="invert_query"
        defaultValue={
          data?.invert_query === true ? 'true' : data?.invert_query === false ? 'false' : 'false'
        }
        onChange={e =>
          onChange(e, 'list_filters_attributes', e.target.value, 'invert_query', idx, '', type_id)
        }
        label="User Template"
      >
        <MenuItem value="false">Like</MenuItem>
        <MenuItem value="true">Not Like</MenuItem>
      </Select>
      {type === 'StatusField' && <MultipleFieldSelect />}
    </FormControl>
  )
}
